import { FormattedMessage } from "react-intl";
import SamblaLogo from "../../assets/sambla.svg";
import { Modal, Title, Button } from "@mantine/core";
import { FooterButtons } from "../footerButtons";

export default function ExitOnboarding({
  opened,
  close,
}: {
  opened: boolean;
  close: () => void;
}) {
  return (
    <Modal.Root
      opened={opened}
      onClose={close}
      fullScreen
      transitionProps={{ transition: "fade", duration: 200 }}
      radius={0}
    >
      <Modal.Content bg="var(--wallet-color-sambla-red-shade-200)">
        <Modal.Header bg="var(--wallet-color-sambla-red-shade-900)" h={76}>
          <SamblaLogo />
          <Modal.CloseButton aria-label="Stäng" style={{ color: "white" }} />
        </Modal.Header>

        <Modal.Body
          display="flex"
          h="calc(100vh - var(--app-shell-header-height, 0px) - var(--app-shell-footer-height, 0px))"
          style={{
            justifyContent: "center",
            m: 0,
            alignItems: "center",
          }}
        >
          <Title order={2}>
            <FormattedMessage
              id="exitOnboarding.title"
              defaultMessage="Are you sure you want to leave your application?"
            />
          </Title>
        </Modal.Body>
        <FooterButtons>
          <Button variant="outline" onClick={close}>
            Nej
          </Button>
          <Button component="a" href={`${import.meta.env.VITE_LANDING_URL}`}>
            Ja
          </Button>
        </FooterButtons>
      </Modal.Content>
    </Modal.Root>
  );
}
